/**
 * @generated SignedSource<<9c8a40634db9cf980b0be90155fd46c8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamHeader_storeViewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"TeamHeaderAssignedBadge_storeViewer" | "TeamPickerPopover_storeViewer">;
  readonly " $fragmentType": "TeamHeader_storeViewer";
};
export type TeamHeader_storeViewer$key = {
  readonly " $data"?: TeamHeader_storeViewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamHeader_storeViewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamHeader_storeViewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamHeaderAssignedBadge_storeViewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamPickerPopover_storeViewer"
    }
  ],
  "type": "StoreViewer",
  "abstractKey": null
};

(node as any).hash = "3d3f27ab66f243c61bef3daf0cdc55cc";

export default node;
